import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';

interface Props {
  formName: string;
  formRef: string;
}

export default function ExtensionToInformationReturns(props: Props) {
  return (
    <Container
      maxWidth="lg"
      sx={{
        mb: 6,
        mt: { xs: -15, sm: -20 },
        backgroundColor: '#1d2337',
        backgroundBlendMode: 'soft-light',
        borderRadius: 4,
        px: { xs: 2, sm: 3 },
        py: 6,
        textAlign: 'center',
      }}
      className="curve-bg"
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
          fontWeight: 600,
          mb: 2,
          textAlign: 'center',
          color: '#fff',
        }}
      >
        More Time Required to File? Request an Extension
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: '#909090' }}>
        If you need additional time to file or send recipient statements,
        <br />
        you can request an extension using the forms below.
      </Typography>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={2}
        mx={2}
        mt={{ xs: 4, md: 4 }}
        pb={0}
        className="MuiGrid-root-width"
        sx={{}}
      >
        <Grid
          size={{ xs: 12, sm: 6, md: 6 }}
          textAlign="center"
          sx={{
            pt: '0 !important',
          }}
        >
          <Box
            sx={{
              backgroundColor: 'rgba(0, 0, 0, .75)',
              backgroundBlendMode: 'soft-light',
              borderRadius: 4,
              px: { xs: 2, lg: 2 },
              py: 3,
              minHeight: '100%',
              border: '2px solid #353b4e',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                color: '#ccc',
              }}
            >
              Form 8809
            </Typography>
            <Typography variant="body1" sx={{ mb: 0, color: '#a2a2a2' }}>
              Request an Extension to File Information Returns
            </Typography>
            <Box
              sx={{
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
                mt: 2,
              }}
            >
              <List sx={{ mb: 0 }}>
                <ListItem
                  sx={{
                    py: 0.5,
                    alignItems: 'flex-start',
                    textAlign: 'center',
                    p: 0,
                  }}
                >
                  <ListItemText sx={{ color: '#ccc' }}>
                    Need extra time to{' '}
                    <span style={{ fontWeight: 600 }}>
                      file your {props.formName}?
                    </span>{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-8809-online/"
                      sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                    >
                      E-file Form 8809
                    </Link>{' '}
                    to request an{' '}
                    <span style={{ fontWeight: 600 }}>
                      automatic 30-day extension
                    </span>{' '}
                    to submit your 1099s to the IRS.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Box>
        </Grid>
        <Grid
          size={{ xs: 12, sm: 6, md: 6 }}
          textAlign="center"
          sx={{
            pt: { sm: '0 !important' },
            // borderLeft: { md: '1px solid #4f4f4f' },
            // borderTop: { xs: '1px solid #4f4f4f', md: '0' },
            // mt: { xs: 3, md: 0 },
          }}
        >
          <Box
            sx={{
              backgroundColor: 'rgba(0, 0, 0, .75)',
              backgroundBlendMode: 'soft-light',
              borderRadius: 4,
              px: { xs: 2, lg: 2 },
              py: 3,
              minHeight: '100%',
              border: '2px solid #353b4e',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                color: '#ccc',
              }}
            >
              Form 15397
            </Typography>
            <Typography variant="body1" sx={{ mb: 0, color: '#909090' }}>
              Request an Extension to Furnish Recipient Statements
            </Typography>
            <Box
              sx={{
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
                mt: 2,
              }}
            >
              <List sx={{ mb: 0 }}>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start', p: 0 }}>
                  <ListItemText sx={{ color: '#ccc', textAlign: 'center' }}>
                    Need extra time to{' '}
                    <span style={{ fontWeight: 600 }}>
                      provide recipient copies
                    </span>{' '}
                    of {props.formName}?{' '}
                    <Link
                      href="/tax-extension/file-irs-form-15397-online/"
                      sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                    >
                      File Form 15397
                    </Link>{' '}
                    to request a{' '}
                    <span style={{ fontWeight: 600 }}>
                      one-time 30-day extension
                    </span>{' '}
                    to furnish 1099 recipient statements.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6 }} textAlign="center">
          <Button
            variant="contained"
            sx={{
              mt: 3,
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            className="btn-secondary"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${props.formRef}`}
          >
            Get Extension Now
          </Button>
          <Typography
            variant="body2"
            sx={{ mt: 1, fontSize: { xs: 11, sm: 14 }, color: '#a2a2a2' }}
          >
            File Extension in Mins
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
